export const products = [
  {
    slug: 'detox',
    name: 'Detox Tea',
    tagline: 'A morning cleanse for the modern body',
    benefits: ['Immunity', 'Digestion', 'Cleanse'],
    ingredients: ['Green tea', 'Hibiscus', 'Fennel', 'Ginger', 'Raw turmeric', 'Pomegranate'],
    caffeine: true,
    color: '#B2422F',
    image: 'https://images.pexels.com/photos/1793034/pexels-photo-1793034.jpeg?auto=compress&cs=tinysrgb&w=1400',
    accentImage: 'https://images.pexels.com/photos/6220709/pexels-photo-6220709.jpeg?auto=compress&cs=tinysrgb&w=1400',
    ritual: 'Sip warm each morning to wake the senses and support gentle daily cleansing.',
  },
  {
    slug: 'bedtime',
    name: 'Bedtime Tea',
    tagline: 'A soft goodnight in a cup',
    benefits: ['Sleep', 'De-stress', 'Calmness'],
    ingredients: ['Chamomile', 'Lavender', 'Ashwagandha', 'Brahmi'],
    caffeine: false,
    color: '#6B4E9B',
    image: 'https://images.pexels.com/photos/8329955/pexels-photo-8329955.jpeg?auto=compress&cs=tinysrgb&w=1400',
    accentImage: 'https://images.pexels.com/photos/8329937/pexels-photo-8329937.jpeg?auto=compress&cs=tinysrgb&w=1400',
    ritual: 'Steep 45 minutes before bed to quiet the mind and slow the breath.',
  },
  {
    slug: 'womens-care',
    name: "Women's Care Tea",
    tagline: 'A daily ritual for hormonal harmony',
    benefits: ['Hormonal balance', 'PMS support', 'Skin health'],
    ingredients: ['Spearmint', 'Shatavri', 'Nettle', 'Ashwagandha'],
    caffeine: false,
    color: '#C97B84',
    image: 'https://images.pexels.com/photos/5389613/pexels-photo-5389613.jpeg?auto=compress&cs=tinysrgb&w=1400',
    accentImage: 'https://images.pexels.com/photos/10584523/pexels-photo-10584523.jpeg?auto=compress&cs=tinysrgb&w=1400',
    ritual: 'Enjoy once daily, warm or iced, to nurture your natural rhythm.',
  },
];

export const goals = [
  { slug: 'better-sleep', title: 'Better Sleep', productSlug: 'bedtime', image: 'https://images.pexels.com/photos/8329955/pexels-photo-8329955.jpeg?auto=compress&cs=tinysrgb&w=900' },
  { slug: 'hormonal-wellness', title: 'Hormonal Wellness', productSlug: 'womens-care', image: 'https://images.pexels.com/photos/10584523/pexels-photo-10584523.jpeg?auto=compress&cs=tinysrgb&w=900' },
  { slug: 'digestion', title: 'Digestion', productSlug: 'detox', image: 'https://images.pexels.com/photos/1793034/pexels-photo-1793034.jpeg?auto=compress&cs=tinysrgb&w=900' },
  { slug: 'immunity', title: 'Immunity', productSlug: 'detox', image: 'https://images.pexels.com/photos/6220709/pexels-photo-6220709.jpeg?auto=compress&cs=tinysrgb&w=900' },
  { slug: 'stress-relief', title: 'Stress Relief', productSlug: 'bedtime', image: 'https://images.pexels.com/photos/34178500/pexels-photo-34178500.jpeg?auto=compress&cs=tinysrgb&w=900' },
  { slug: 'skin-health', title: 'Skin Health', productSlug: 'womens-care', image: 'https://images.pexels.com/photos/5389613/pexels-photo-5389613.jpeg?auto=compress&cs=tinysrgb&w=900' },
];

export const quizAnswers = {
  sleep: 'bedtime',
  stress: 'bedtime',
  digestion: 'detox',
  hormonal: 'womens-care',
  immunity: 'detox',
  skin: 'womens-care',
};
